
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/help/why-choose-us",
      function () {
        return require("private-next-pages/[locale]/help/why-choose-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/help/why-choose-us"])
      });
    }
  